// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';

// Afidium
import { IApiProcessingSearchResponse } from "./IApiProcessingSearchResponse";
import { ApiProcessingSearchParameters } from "./ApiProcessingSearchParameters";
import { IProcessingSearchParameters } from "./IProcessingSearchParameters";
import { IProcessing } from "./IProcessing";
import { ApiResourceService } from 'libraries/service/apiResource/apiResource.service';
import {
    ICreateProcessingRequest,
    ICreateProcessingResponse,
    IProcessingParameter
} from 'libraries/service/resources/model/processing/ICreateProcessing';
import { ITask } from 'libraries/service/resources/booking-task-resource/ITask';
import { IHeader } from "libraries/service/resource/IHeader";

interface IParametersGetCache {
    nbrecord: number;
}

@Injectable()
export class ProcessingResourceService {
    private parametersGetCache: IParametersGetCache = {nbrecord: 50};

    constructor(private readonly apiResource: ApiResourceService) {
    }

    public search(parameters: IProcessingSearchParameters): Observable<IApiProcessingSearchResponse> {
        return this.apiResource.postOne<ApiProcessingSearchParameters, IApiProcessingSearchResponse>(
            this.apiResource.getApiUrl('booking', 'processings', 'search'),
            ApiProcessingSearchParameters.fromSearchParameters(parameters)
        );
    }

    public get(id: string, first: number = 1, nbrecord?: number, status?: string): Observable<IProcessing> {

        if (nbrecord) {
            this.parametersGetCache = {nbrecord};
        }

        return this.apiResource.getOne<IProcessing>(
            this.apiResource.getApiUrl('booking', 'processings', id),
            status ?
                {first, nbrecord: this.parametersGetCache.nbrecord, status}:
                {first, nbrecord: this.parametersGetCache.nbrecord}
        );
    }

    public create<TRequest extends ICreateProcessingRequest<TParameter>,
        TResponse extends ICreateProcessingResponse<TParameter>,
        TParameter extends IProcessingParameter>(body: TRequest): Observable<TResponse> {
        return this.apiResource.putOne<ICreateProcessingRequest<TParameter>, TResponse>(
            this.apiResource.getApiUrl('booking', 'processings'),
            body
        );
    }

    public relaunchTasks(processingId: number, taskIds: number[]): Observable<ITask[] | ITask> {
        return this.apiResource.patch(
            this.apiResource.getApiUrl('booking', 'processings', processingId, 'tasks', taskIds.join(',')),
            {
                status: 'pending'
            }
        );
    }
}
